import { scaleLinear } from "d3-scale"
export const gradientColors = [
  { offset: 0, hex: "#D40276" },
  { offset: 10.3, hex: "#D40276" },
  { offset: 22.17, hex: "#EA1813" },
  { offset: 38.42, hex: "#F19D4B" },
  { offset: 50, hex: "#F6C600" },
  { offset: 67.68, hex: "#ADC493" },
  { offset: 77.58, hex: "#6A9E89" },
  { offset: 88.65, hex: "#125459" },
  { offset: 96.99, hex: "#003632" },
  { offset: 100, hex: "#003632" },
]

export default scaleLinear()
  .domain(gradientColors.map((d) => d.offset / 100))
  .range(gradientColors.map((d) => d.hex))
